import React from "react";
import PageHero from "../components/PageHero";
import { ExternalLink } from "lucide-react";

const trainingPartners = [
  { name: "HWK, Koblenz", role: "German Chamber of Skilled Crafts", img: "https://kikicentre.com/wp-content/uploads/2020/04/koblonz-logo1.jpg" },
  { name: "Mitsubishi Electric Systems", role: "Training Partner", img: "https://kikicentre.com/wp-content/uploads/2020/04/Mitsubishi-Sticker.jpg" },
  { name: "Moldex 3D", role: "Training Partner", img: "https://kikicentre.com/wp-content/uploads/2020/04/Moldex3d.jpg" },
  { name: "Alumniportal", role: "Relevant Link", img: "https://kikicentre.com/wp-content/uploads/2020/04/Alumniportal.jpg" },
];

export default function PartnersPage() {
  return (
    <div data-testid="partners-page">
      <PageHero
        path="partners.hero"
        kicker="Our Partners"
        title="Backed by global leaders"
        subtitle="From German certifying bodies to leading technology companies, our partner network powers world-class training."
      />

      {/* HWK Koblenz partnership */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <img src="https://kikicentre.com/wp-content/uploads/2022/03/partnerlogo.png" alt="Handwerkskammer Koblenz" className="h-16 w-auto object-contain mb-6" />
            <h2 className="text-2xl font-bold text-[#0B2A6B] mb-4">Handwerkskammer Koblenz</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Since 2011, Kiki Centre for Technology has engaged in a partnership with the German Chamber of Skilled Crafts,
              Koblenz, Germany (HWK, Koblenz). HWK Koblenz supports Kiki with the implementation of the Earn While You Learn
              courses according to German standards, and supports adaptation of the German curriculum from training right up to
              certification.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4">
              Training certified through HWK, Koblenz follows high German quality standards — both in terms of equipment and
              training content. At the moment 3 courses are covered in the professions of:
            </p>
            <ul className="space-y-2 mb-6">
              {["Mechanical – Tool & Die Making", "Mechanical – Precision Machinist", "Electrical & Electronics – Mechatronics"].map((p) => (
                <li key={p} className="flex items-start gap-2 text-slate-700 font-semibold">
                  <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-yellow-400 shrink-0" />{p}
                </li>
              ))}
            </ul>
            <a href="https://www.hwk-koblenz.de" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-yellow-600 font-bold hover:gap-2.5 transition-all" data-testid="hwk-website-link">
              Visit hwk-koblenz.de <ExternalLink className="h-4 w-4" />
            </a>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-lg">
            <img src="https://kikicentre.com/wp-content/uploads/2026/04/partnr-1.jpg" alt="HWK Koblenz partnership" className="w-full h-full object-cover" />
          </div>
        </div>
      </section>

      {/* Training partners */}
      <section className="py-16 bg-slate-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <p className="kicker mb-3">Training Partners</p>
            <h2 className="text-3xl font-bold text-[#0B2A6B]">Companies we work with</h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {trainingPartners.map((p, i) => (
              <div key={p.name} className="bg-white rounded-2xl p-6 border border-slate-100 shadow-sm tilt-card animate-fade-up flex flex-col items-center text-center" style={{ animationDelay: `${i * 0.06}s` }} data-testid={`partner-${i}`}>
                <div className="h-28 w-full flex items-center justify-center mb-4">
                  <img src={p.img} alt={p.name} className="max-h-24 max-w-full object-contain" />
                </div>
                <h3 className="font-bold text-[#0B2A6B]">{p.name}</h3>
                <p className="text-sm text-slate-500 mt-1">{p.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
